import { event } from "vue-analytics";

const SET_ROUTE = "SET_ROUTE";
const SET_ACTIVE = "SET_ACTIVE";
const SET_OPENED_MENU = "SET_OPENED_MENU";

export default {
  namespaced: true,

  state: {
    route: "",
    active: null,
    menuOpened: false
  },

  actions: {
    changeMenu({ commit }, payload) {
      event("cliente", "click", `Menu:${payload}`);
      commit(SET_ACTIVE, payload);
    },
    changeMenuOpened({ commit }, payload) {
      commit(SET_OPENED_MENU, payload);
    },
    changeRoute({ commit }, payload) {
      commit(SET_ROUTE, payload);
    }
  },

  mutations: {
    [SET_ACTIVE](state, payload) {
      state.active = payload;
    },
    [SET_OPENED_MENU](state, payload) {
      state.menuOpened = payload;
    },
    [SET_ROUTE](state, payload) {
      state.route = payload;
    }
  },

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/menu.js